import React from 'react';
import { complianceTypeLabel } from './complianceIssuePresenters';

const TYPE_ORDER = ['building_code', 'client_requirements', 'standards'];

export default function ComplianceHeroRow({
  overviewStats,
  issueKpis,
  activeStatusFilter,
  onKpiClick,
}) {
  const { byType, overall } = overviewStats || { byType: {}, overall: null };

  return (
    <div className="hero-row">
      <div className="hero-group" style={{ flex: 1.5 }}>
        <div className="group-inner">
          <div className="hero-group-label">Compliance Overview</div>
          <div className="compliance-cards">
            <div className="compliance-card overall">
              <div className="card-value">{overall != null ? `${overall}%` : 'n/a'}</div>
              <div className="card-label">Overall</div>
              <div className="card-bar">
                <div
                  className="card-bar-fill"
                  style={{ width: overall != null ? `${overall}%` : '0%' }}
                />
              </div>
            </div>
            {TYPE_ORDER.map((type) => {
              const pct = byType[type]?.pct;
              return (
                <div key={type} className="compliance-card">
                  <div className="card-value">{pct != null ? `${pct}%` : 'n/a'}</div>
                  <div className="card-label">{complianceTypeLabel(type)}</div>
                  <div className="card-bar">
                    <div
                      className="card-bar-fill"
                      style={{ width: pct != null ? `${pct}%` : '0%' }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="hero-group" style={{ flex: 1 }}>
        <div className="group-inner">
          <div className="hero-group-label">Issue Summary</div>
          <div className="kpi-cards">
            {[
              { key: 'open', label: 'Open', className: 'open' },
              { key: 'in_progress', label: 'In Progress', className: 'in-progress' },
              { key: 'resolved', label: 'Resolved', className: 'resolved' },
              { key: 'dismissed', label: 'Dismissed', className: 'dismissed' },
            ].map(({ key, label, className }) => (
              <div
                key={key}
                className={`kpi-card ${className}${activeStatusFilter === key ? ' active-filter' : ''}`}
                onClick={() => onKpiClick && onKpiClick(key)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onKpiClick && onKpiClick(key);
                  }
                }}
                role="button"
                tabIndex={0}
              >
                <div className="kpi-value">{issueKpis[key] ?? 0}</div>
                <div className="kpi-label">{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
